// Original Here: https://github.com/gregberge/react-merge-refs/blob/main/src/index.tsx
import { Ref, RefCallback, RefObject } from 'react';


/**
 * @description Merges multiple refs into a single ref callback.
 * @param refs an array of refs to merge
 *
 * @example
 * <div ref={mergeRefs([ref1, ref2])} />
 */
export function mergeRefs<T>(
  refs: Array<RefObject<T> | Ref<T>>,
): RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as RefObject<T | null>).current = value;
      }
    });
  };
}
